/*
  SR Complete the Set (snippets/sr-pdp-bundle.liquid + sr-pdp-bundle-item.liquid).
  Uses the theme globals from global.js / theme.liquid: fetchConfig, routes, cartStrings,
  variantStrings, subscribe, publish, PUB_SUB_EVENTS.
*/
if (!customElements.get('sr-bundle')) {
  customElements.define(
    'sr-bundle',
    class SrBundle extends HTMLElement {
      connectedCallback() {
        this.money = JSON.parse(this.querySelector('[data-srb-data]').textContent).money;
        this.disc = parseFloat(this.dataset.disc) || 0;
        this.tiers = (this.dataset.tiers || '')
          .split(',')
          .map((tier) => tier.split(':').map(Number))
          .filter(([min, pct]) => min > 0 && pct > 0);
        this.items = {};
        this.querySelectorAll('[data-srb-item]').forEach((el) => {
          this.items[el.dataset.srbItem] = {
            el,
            variants: JSON.parse(el.querySelector('[data-srb-variants]').textContent),
            dropdowns: [...el.querySelectorAll('[data-srb-dd]')],
            picked: false,
          };
        });
        this.toggle = this.querySelector('[data-srb-toggle]');
        this.button = this.querySelector('[data-srb-add]');
        this.buttonLabel = this.querySelector('[data-srb-add-label]');
        this.spinner = this.button.querySelector('.loading__spinner');
        this.message = this.querySelector('[data-srb-msg]');

        Object.values(this.items).forEach((item) => {
          item.dropdowns.forEach((dd) => {
            dd.addEventListener('toggle', () => {
              if (dd.open) this.closeDropdowns(dd);
            });
            dd.querySelectorAll('.srb-dd__opt').forEach((opt) =>
              opt.addEventListener('click', () => {
                this.setOption(dd, opt.dataset.value);
                item.picked = true;
                dd.open = false;
                this.update();
              })
            );
          });
        });
        if (this.toggle) this.toggle.addEventListener('change', () => this.update());
        this.button.addEventListener('click', () => this.addToCart());

        this.onOutsideClick = (event) => {
          if (!this.contains(event.target)) this.closeDropdowns();
        };
        document.addEventListener('click', this.onOutsideClick);
        this.addEventListener('keyup', (event) => {
          if (event.code === 'Escape') this.closeDropdowns();
        });

        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data && event.data.variant) this.syncWithPage(event.data.variant.options);
          });
        }
        this.update();
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        document.removeEventListener('click', this.onOutsideClick);
      }

      closeDropdowns(except) {
        this.querySelectorAll('[data-srb-dd][open]').forEach((dd) => {
          if (dd !== except) dd.open = false;
        });
      }

      setOption(dd, value) {
        dd.dataset.current = value;
        dd.querySelector('[data-srb-dd-value]').textContent = value.replace('Cubic Zirconia', 'CZ');
        dd.querySelectorAll('.srb-dd__opt').forEach((opt) =>
          opt.setAttribute('aria-selected', opt.dataset.value === value ? 'true' : 'false')
        );
      }

      // Page variant changed: follow it in the main item, and in the pair for options with the same name.
      syncWithPage(options) {
        const main = this.items.main;
        if (!main) return;
        const byName = {};
        main.dropdowns.forEach((dd, i) => {
          if (options[i] === undefined) return;
          byName[dd.dataset.name.toLowerCase()] = options[i];
          if (!main.picked) this.setOption(dd, options[i]);
        });
        const pair = this.items.pair;
        if (pair && !pair.picked) {
          pair.dropdowns.forEach((dd) => {
            const value = byName[dd.dataset.name.toLowerCase()];
            if (value && dd.querySelector(`[data-value="${CSS.escape(value)}"]`)) this.setOption(dd, value);
          });
        }
        this.update();
      }

      currentVariant(item) {
        const values = item.dropdowns.map(
          (dd) => dd.dataset.current || dd.querySelector('[aria-selected="true"]').dataset.value
        );
        return item.variants.find((v) => v.options.every((o, i) => o === values[i])) || null;
      }

      // Shop money format ({{ shop.money_format }}), same placeholders as Shopify's formatMoney.
      format(cents) {
        const split = (value, decimals, thousands, decimal) => {
          const [int, dec] = (value / 100).toFixed(decimals).split('.');
          return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (dec ? decimal + dec : '');
        };
        return this.money.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
          switch (key) {
            case 'amount_no_decimals':
              return split(cents, 0, ',', '.');
            case 'amount_with_comma_separator':
              return split(cents, 2, '.', ',');
            case 'amount_no_decimals_with_comma_separator':
              return split(cents, 0, '.', ',');
            case 'amount_with_apostrophe_separator':
              return split(cents, 2, "'", '.');
            default:
              return split(cents, 2, ',', '.');
          }
        });
      }

      update() {
        const main = this.currentVariant(this.items.main);
        const pair = this.currentVariant(this.items.pair);
        const withPair = !this.toggle || this.toggle.checked;
        const ok = main && main.available && (!withPair || (pair && pair.available));

        const mainPrice = main ? main.price : 0;
        const pairPrice = pair ? pair.price : 0;
        const pairSale = pairPrice - Math.floor((pairPrice * this.disc) / 100);
        const regular = mainPrice + (withPair ? pairPrice : 0);
        let sale = mainPrice + (withPair ? pairSale : 0);
        this.tiers.forEach(([min, pct]) => {
          if (regular >= min * 100) sale = Math.min(sale, regular - Math.floor((regular * pct) / 100));
        });
        const pairDiscountWins = withPair && pairSale < pairPrice && sale === mainPrice + pairSale;

        this.setText(this.items.main.el, '[data-srb-item-price]', this.format(mainPrice));
        this.setText(this.items.pair.el, '[data-srb-item-reg]', pairDiscountWins ? this.format(pairPrice) : '');
        this.setText(this.items.pair.el, '[data-srb-item-price]', this.format(pairDiscountWins ? pairSale : pairPrice));
        this.setText(this, '[data-srb-reg]', sale < regular ? this.format(regular) : '');
        this.setText(this, '[data-srb-sale]', this.format(sale));
        const saveText = (this.dataset.saveText || '').replace('[amount]', this.format(regular - sale));
        this.setText(this, '[data-srb-save]', sale < regular ? saveText : '');

        let label = withPair ? this.dataset.labelBoth : this.dataset.labelOne;
        if (!ok) label = window.variantStrings ? variantStrings.unavailable : label;
        this.buttonLabel.textContent = label;
        this.button.toggleAttribute('disabled', !ok);
        this.selection = { main, pair: withPair ? pair : null };
      }

      setText(root, selector, text) {
        root.querySelectorAll(selector).forEach((el) => (el.textContent = text));
      }

      addToCart() {
        if (!this.selection || !this.selection.main) return;
        const items = [{ id: this.selection.main.id, quantity: 1 }];
        if (this.selection.pair) items.push({ id: this.selection.pair.id, quantity: 1 });

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        const body = { items };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement(document.activeElement);
        }
        config.body = JSON.stringify(body);

        this.message.hidden = true;
        this.button.setAttribute('aria-disabled', true);
        this.button.classList.add('loading');
        if (this.spinner) this.spinner.classList.remove('hidden');

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, { source: 'sr-bundle', errors: response.description, message: response.message });
              this.message.textContent = response.description || response.message;
              this.message.hidden = false;
              return;
            }
            if (!cart) {
              window.location = routes.cart_url;
              return;
            }
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sr-bundle', cartData: response });
            cart.renderContents(response);
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          })
          .catch(() => {
            this.message.textContent = window.cartStrings ? cartStrings.error : 'Error';
            this.message.hidden = false;
          })
          .finally(() => {
            this.button.classList.remove('loading');
            this.button.removeAttribute('aria-disabled');
            if (this.spinner) this.spinner.classList.add('hidden');
          });
      }
    }
  );
}
